import { ValidatorBase } from './ValidatorBase'

// Checks the maximum length of a string.
export class MaxLengthValidator extends ValidatorBase {

    public constructor(message: string, data: string) {
        super(message, data);
    }

    public validate(value: string, messages: string[]) {
        let maxLength = parseInt(this._data);
        if (value.length > maxLength) {
            messages.push("The maximum length should be " + maxLength + " characters.");
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/ConfigurationPanel/Validators/MaxLengthValidator.ts
 **/